import { ActionLog, createNullAction } from "./ActionLog"
import { ActionLogStore } from "./actionLogReducer"

function getActionStore(state): ActionLogStore {
    return state.actionLogReducer as ActionLogStore
}

export function getAction(state, actionId): ActionLog {
    const latestActionLog = 
        getActionStore(state)
            .logs
            .find(l => l.actionId == actionId)
    if (!latestActionLog) {
        return createNullAction(actionId)
    }
    return latestActionLog
}


// WEBPACK FOOTER //
// ./src/state/actionlog/actionLogSelector.ts